export default __webpack_public_path__ + "static/media/factory__46.5a084d57.jpg";